module.exports = __webpack_public_path__ + "assets/sentiment_negative_white.13ef9c66.svg";